import type { FC } from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { QueryKeyENUM } from '../../atoms/Filters/ApplyFilters.model'
import type { IFilterProps, ItemType } from '../ApplyFilters.model'
import { FilterItem } from '../components/FilterItem/FilterItem'
import { SFilterBlock, SFilterList, STitle } from '../Filters.styled'

export const Duration = [
  { name: 'До 13 часов', id: '-13' },
  { name: 'с 13 до 36 часов', id: '13-36' },
  { name: 'с 37 до 71 часа', id: '37-71' },
  { name: '72 и более часов', id: '72+' },
]

const normalizeDuration = (item: ItemType | null) => {
  if (!item) return item
  const legacyId = String(item.id ?? item.value)
  const id = ({ '37-72': '37-71', '73+': '72+' } as Record<string, string>)[
    legacyId
  ]
  const duration = Duration.find((entry) => entry.id === id)
  return duration ? { ...item, ...duration, value: duration.id } : item
}

export const DurationFilter: FC<IFilterProps> = ({ setFilters, prevState }) => {
  const [selectedDuration, setSelectedDuration] = useState<ItemType | null>(
    normalizeDuration(prevState),
  )

  useEffect(() => {
    const normalized = normalizeDuration(prevState)
    setSelectedDuration(normalized)
    if (normalized && normalized.id !== prevState?.id) {
      setFilters(QueryKeyENUM.programDurationInHours, normalized)
    }
  }, [prevState, setFilters])

  const handleSetItem = useCallback(
    (item: ItemType) => {
      if (selectedDuration?.id === item.id) {
        setFilters(QueryKeyENUM.programDurationInHours, null)
        setSelectedDuration(null)
      } else {
        setSelectedDuration(item)
        setFilters(QueryKeyENUM.programDurationInHours, {
          ...item,
          value: item.id,
        })
      }
    },
    [selectedDuration, setFilters],
  )

  const content = useMemo(
    () =>
      Duration.map((d) => (
        <FilterItem
          key={d.id}
          item={d}
          setItem={handleSetItem}
          active={selectedDuration?.id === d.id}
        />
      )),
    [handleSetItem, selectedDuration],
  )

  return (
    <SFilterBlock>
      <STitle>Продолжительность</STitle>
      <SFilterList>{content}</SFilterList>
    </SFilterBlock>
  )
}
